import { SourceControlProvider } from "@modules/graphql/types"
import { sourceControl as sourceControlText } from "@modules/locales/default.js"

export const sourceControlProviderLabels: Record<
  SourceControlProvider,
  string
> = {
  [SourceControlProvider.Github]: sourceControlText.morphemes.github,
  [SourceControlProvider.GithubEnterprise]:
    sourceControlText.morphemes.githubEnterprise,
  [SourceControlProvider.GitlabSelfManaged]:
    sourceControlText.morphemes.gitlabSelfManaged,
  [SourceControlProvider.Gitlab]: sourceControlText.morphemes.gitlab,
  [SourceControlProvider.Bitbucket]: sourceControlText.morphemes.bitbucket,
  [SourceControlProvider.Google]: sourceControlText.morphemes.google,
  [SourceControlProvider.Workos]: sourceControlText.morphemes.google,
}
